module.exports = ['$analytics', '$uibModal', currencyCodeSelectorModal];

function currencyCodeSelectorModal($analytics, $uibModal) {
    var modal = {
        show: showModal
    };

    currencyCodeSelectorModalController.$inject = ['$uibModalInstance', 'possibleCurrencyCodes', 'currencyCode'];

    function currencyCodeSelectorModalController($uibModalInstance, possibleCurrencyCodes, currencyCode) {
        var vm = {
            currencyCode: currencyCode,
            cancel: cancel,
            possibleCurrencyCodes: possibleCurrencyCodes,
            ok: ok
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function ok(code) {
            $uibModalInstance.close(code);
        }

        return vm;
    }

    function showModal(possibleCurrencyCodes, currencyCode) {
        $analytics.eventTrack('open-modal-currency-selector', { category: 'exchange-rates' });
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: currencyCodeSelectorModalController,
            controllerAs: 'ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                currencyCode: function () {
                    return currencyCode;
                },
                possibleCurrencyCodes: function () {
                    return possibleCurrencyCodes;
                }
            },
            size: 'lg',
            templateUrl: 'exchange-rates/modals/currency-selector.html',
            windowClass: 'modal-currency-code-selector'
        });

        modalInstance.rendered.then(function() {
            var elementToFocusOnInModal = document.querySelector('.modal.in .focus-on-open-modal');
            if (elementToFocusOnInModal) {
                elementToFocusOnInModal.focus();
            }
        });

        return modalInstance;
    }

    return modal;
}
